module.exports = __webpack_public_path__ + "img/12_73.31874133.png";